import * as React from "react"
import { Skeleton } from "@mui/material"
import { PieAmchartSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { GROUPED_BY } from "@constants"
import { useCatalogueAnalyzerShareProductsChart } from "./@hooks"
import { catalogueAnalyzerTabSelected } from "../@signals"


const HEIGHT = 460

export default function CatalogueAnalyzerShareProductsChart() {

    const { isLoading, data, title } = useCatalogueAnalyzerShareProductsChart()
	
	if (isLoading) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!data.length) return <></>

	return <PieAmchartSeeker
			rootID="ShareProducts"
			data={data}
			title={<TitleWithPopover title={title} />}
			series={[{
				yField: 'label',
				xField: "value",
				innerRadius: 60,
			}]}
			chartProps={{
				legend: catalogueAnalyzerTabSelected.value === GROUPED_BY.CATEGORY ? { hidden: true } : {}
			}}
			sx={{ height: HEIGHT }}
	/>
}